import { UITableViewCell, UILabel, UITextField, UIButton, UIControl, UIImageView } from "uikit";

export class BookingProductCategoryCell extends UITableViewCell
{
    private imageView: UIImageView;
    private nameLabel: UILabel;
    private infoLabel: UILabel;    

    awakeFromNib (  ) { }

    private _category: any = null;
    set category ( category: any ) {
        this._category = category;
        if (category["ImageURL"]) this.imageView.imageURL = category["ImageURL"] ;
        this.nameLabel.text = category["Name"] ;
        this.infoLabel.text = category["OnlineInfo"] ;
    }

}
